import { render, staticRenderFns } from "./Pergunta.vue?vue&type=template&id=30c65281&"
import script from "./Pergunta.vue?vue&type=script&lang=js&"
export * from "./Pergunta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports